import Parameter, { BoolClause } from './Parameter';
import ParameterKeyValue from './ParameterKeyValue';

export default class SubscriberFilter extends Parameter {
  private _patientId: string;

  constructor(patientId: string) {
    super();
    this._patientId = patientId;
  }

  get parameterKeyValue(): ParameterKeyValue {
    return new ParameterKeyValue('subscriber', this._patientId);
  }

  async getFSSClause(): Promise<BoolClause | null> {
    if (!this._patientId) {
      return null;
    }

    return this._getFSSPatientReferenceClause(
      'subscriber.reference.keyword',
      this._patientId,
    );
  }
}
